import moment from 'moment-timezone';
// biome-ignore lint/correctness/noUnusedImports: existing error
import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {UPDATE_MULTIPLE_DATES_MODAL_REPEATING_TAB} from '~/SignUpSheets/reducers/sheet/constants';
import {
  selectMultipleDatesModalEndDate,
  selectMultipleDatesModalStartDate,
} from '~/SignUpSheets/reducers/sheet/selectors';
import {DatePicker} from '~library/atoms/DatePicker';
import {CalendarLineIcon} from '~library/svg/CalendarLineIcon';

import './DatesSelector.sass';

export const DatesSelector = () => {
  const dispatch = useDispatch();
  const startDate = useSelector(selectMultipleDatesModalStartDate);
  const endDate = useSelector(selectMultipleDatesModalEndDate);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const onChangeStartDateHandler = useCallback(([date]) => {
    const d = moment(date);
    dispatch({
      type: UPDATE_MULTIPLE_DATES_MODAL_REPEATING_TAB,
      payload: {startDate: d.toISOString()},
    });
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const onChangeEndDateHandler = useCallback(([date]) => {
    const d = moment(date);
    dispatch({
      type: UPDATE_MULTIPLE_DATES_MODAL_REPEATING_TAB,
      payload: {endDate: d.toISOString()},
    });
  }, []);

  return (
    <div className="add-multiple-dates__dates_selector__form-group">
      <DatePicker
        label="START DATE"
        id="start-date"
        name="date"
        data-qa-id="start-date"
        type="text"
        value={moment(startDate).format('YYYY-MM-DD')}
        minDate={moment().format('YYYY-MM-DD')}
        placeholder="empty"
        onChange={onChangeStartDateHandler}
        endAdornment={<CalendarLineIcon ratio={0.75} />}
        containerClassName="add-multiple-dates__dates_selector"
      />

      <DatePicker
        label="END DATE"
        id="end-date"
        name="date"
        data-qa-id="end-date"
        type="text"
        value={endDate ? moment(endDate).format('YYYY-MM-DD') : null}
        minDate={moment(startDate).format('YYYY-MM-DD')}
        placeholder="empty"
        onChange={onChangeEndDateHandler}
        endAdornment={<CalendarLineIcon ratio={0.75} />}
        containerClassName="add-multiple-dates__dates_selector"
      />
    </div>
  );
};
